// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ExemptionReason {
  A1 = "A1",
  A2 = "A2",
  A3 = "A3",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  F = "F",
  G = "G",
  J = "J",
  K = "K",
  M = "M",
  N = "N",
  O = "O",
  O1 = "O1",
  O2 = "O2",
  P = "P",
}
export default ExemptionReason;
